export default "__VITE_ASSET__D$FZ2ZFt__"